<div id="appDiv" class="panel panel-primary">
    @if (Loading) {
        <div class="loading"></div>
    }
    <div class="panel-heading">
        Purchase Request - {{ PORequest.CreatedBy?.UserName }}
        <div class="pull-right">
            <nz-space-compact>
                @if (HasStepPermission(PORequest.StepID) && !PORequest.Canceled && !PORequest.Complete) {
                    <button nz-button class="pf-form-action" (click)="Update()">
                        <span class="fa-solid fa-floppy-disk"></span>Save
                    </button>
                }
                @if (HasStepPermission(PORequest.StepID) && !PORequest.Canceled && !PORequest.Complete) {
                    <button nz-button class="pf-form-action" (click)="ApproveItem(PORequest, 0, PORequest.PORequestID)">
                        <img src="assets/images/ptp/approve.png" alt="" />Approve
                    </button>
                }
                @if (IsFirstStep(PORequest.StepID) && !PORequest.Canceled && !PORequest.Complete) {
                    <button nz-button class="pf-form-action" (click)="CancelItem(PORequest, cancelModal)">
                        <img src="assets/images/ptp/deny.png" alt="" />Cancel
                    </button>
                }
                @if (
                    HasStepPermission(PORequest.StepID) &&
                    !PORequest.Canceled &&
                    !PORequest.Complete &&
                    PORequest.DenyVisible
                ) {
                    <button nz-button class="pf-form-action" (click)="DenyItem(PORequest, denyModal)">
                        <img src="assets/images/ptp/deny.png" alt="" />Deny
                    </button>
                }
                @if (!HasStepPermission(PORequest.StepID) || PORequest.Complete || PORequest.Canceled) {
                    <button nz-button class="pf-form-action" (click)="CloseWindow()">Close</button>
                }
            </nz-space-compact>
        </div>
    </div>
    <div class="panel-body">
        <div class="panel panel-default">
            <div class="panel-heading">Request Information</div>
            <div class="panel-body">
                <div role="form" class="form-horizontal">
                    <div class="form-group">
                        <div class="col-md-2 control-label">Request #</div>
                        <div class="col-md-2">
                            <input
                                type="text"
                                readonly="readonly"
                                [ngModelOptions]="{standalone: true}"
                                [(ngModel)]="PORequest.PORequestID"
                                class="form-control" />
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-md-2 control-label">Items Requested</div>
                        <div class="col-md-10">
                            <textarea
                                [(ngModel)]="PORequest.NeedNotes"
                                [ngModelOptions]="{standalone: true}"
                                class="form-control"
                                style="height: 100px; margin-bottom: 15px"></textarea>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-md-2 control-label">Reason for request</div>
                        <div class="col-md-10">
                            <textarea
                                [(ngModel)]="PORequest.NeedReasonNotes"
                                [ngModelOptions]="{standalone: true}"
                                class="form-control"
                                style="height: 100px"></textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="panel panel-default">
            <div class="panel-heading">General Information</div>
            <div class="panel-body">
                <div role="form" class="form-horizontal">
                    <div class="form-group">
                        <div class="col-md-2 control-label">Requested By</div>
                        <div class="col-md-4">
                            <input
                                type="text"
                                readonly="readonly"
                                [value]="$safeNavigationMigration(PORequest.CreatedBy?.UserName)"
                                class="form-control" />
                        </div>
                        <div class="col-md-2 control-label">Created Date</div>
                        <div class="col-md-4">
                            <input type="text" readonly="readonly" [value]="CreateDateDisplay" class="form-control" />
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-md-2 control-label">Vendor Contact</div>
                        <div class="col-md-4">
                            <input
                                type="text"
                                [ngModelOptions]="{standalone: true}"
                                [(ngModel)]="PORequest.VendorContact"
                                class="form-control" />
                        </div>
                        <div class="col-md-2 control-label {{ getVendorErrorStatus() }}">
                            @if (RequiresVendorNameAndNumber(this.PORequest)) {
                                <span style="color: red">*</span>
                            }
                            Vendor Name
                        </div>
                        <div class="col-md-4 {{ getVendorErrorStatus() }}">
                            <input
                                type="text"
                                [ngModelOptions]="{standalone: true}"
                                [(ngModel)]="PORequest.VendorName"
                                (keyup)="ValidateVendorName()"
                                #venName="ngModel"
                                required
                                class="form-control" />
                            @if (HasVendorNameError) {
                                <span class="text-danger">Vendor Name is Required</span>
                            }
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-md-2 control-label {{ getErrorStatus() }}">
                            <span style="color: red">*</span> Location
                        </div>
                        <div class="col-md-4 {{ getErrorStatus() }}">
                            <select
                                class="form-control"
                                name="location"
                                required
                                [(ngModel)]="PORequest.Location"
                                [ngModelOptions]="{standalone: true}"
                                (ngModelChange)="SelectShippingPOLocation()">
                                <option value=""></option>
                                @for (location of Locations; track location) {
                                    <option [ngValue]="location.PTPShippingLocationID">
                                        {{ location.ShippingLocation }}
                                    </option>
                                }
                            </select>
                            @if (HasLocationError) {
                                <span class="text-danger">Please choose a Location</span>
                            }
                        </div>
                        <div class="col-md-2 control-label">Department</div>
                        <div class="col-md-4">
                            <select
                                class="form-control"
                                [ngModelOptions]="{standalone: true}"
                                [(ngModel)]="PORequest.Department">
                                @for (department of Departments; track department) {
                                    <option [ngValue]="department.DepartmentID">
                                        {{ department.DepartmentName }}
                                    </option>
                                }
                            </select>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-md-2 control-label {{ getVendorErrorStatus() }}">
                            @if (RequiresVendorNameAndNumber(this.PORequest)) {
                                <span style="color: red">*</span>
                            }
                            Vendor Number
                        </div>
                        <div class="col-md-4 {{ getVendorErrorStatus() }}">
                            <input
                                type="text"
                                [ngModelOptions]="{standalone: true}"
                                [(ngModel)]="PORequest.VendorNumber"
                                (keyup)="ValidateVendorNumber()"
                                #venNum="ngModel"
                                required
                                class="form-control" />
                            @if (HasVendorNumberError) {
                                <span class="text-danger">Vendor Number is Required</span>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="panel panel-default">
            <div class="panel-heading">Shipping Information</div>
            <div class="panel-body">
                <div role="form" class="form-horizontal">
                    <div class="form-group">
                        <div class="col-md-2 control-label">Ship To Address 1</div>
                        <div class="col-md-4">
                            <input
                                type="text"
                                [ngModelOptions]="{standalone: true}"
                                [(ngModel)]="PORequest.ShipToAddress1"
                                class="form-control" />
                        </div>
                        <div class="col-md-2 control-label">Ship To Address 2</div>
                        <div class="col-md-4">
                            <input
                                type="text"
                                [ngModelOptions]="{standalone: true}"
                                [(ngModel)]="PORequest.ShipToAddress2"
                                class="form-control" />
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-md-2 control-label">Ship To City</div>
                        <div class="col-md-2">
                            <input
                                type="text"
                                [ngModelOptions]="{standalone: true}"
                                [(ngModel)]="PORequest.ShipToCity"
                                class="form-control" />
                        </div>
                        <div class="col-md-2 control-label">Ship To State</div>
                        <div class="col-md-2">
                            <input
                                type="text"
                                [ngModelOptions]="{standalone: true}"
                                [(ngModel)]="PORequest.ShipToState"
                                class="form-control" />
                        </div>
                        <div class="col-md-2 control-label">Ship To Postal Code</div>
                        <div class="col-md-2">
                            <input
                                type="text"
                                [ngModelOptions]="{standalone: true}"
                                [(ngModel)]="PORequest.ShipToZip"
                                class="form-control" />
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-md-2 control-label">Ship To Email</div>
                        <div class="col-md-2">
                            <input
                                type="email"
                                [ngModelOptions]="{standalone: true}"
                                [(ngModel)]="PORequest.ShipToEmail"
                                class="form-control" />
                        </div>
                        <div class="col-md-2 control-label">Ship To Phone</div>
                        <div class="col-md-2">
                            <input
                                type="text"
                                [ngModelOptions]="{standalone: true}"
                                [(ngModel)]="PORequest.ShipToPhone"
                                class="form-control" />
                        </div>
                        <div class="col-md-2 control-label">Ship To Country</div>
                        <div class="col-md-2">
                            <input
                                type="text"
                                [ngModelOptions]="{standalone: true}"
                                [(ngModel)]="PORequest.ShipToCountry"
                                class="form-control" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="panel panel-default">
            <div class="panel-heading">Vendor Information</div>
            <div class="panel-body">
                <div class="form-horizontal" role="form">
                    <div class="form-group">
                        <div class="col-md-2 control-label">Attachments</div>
                        <div class="col-md-10">
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th>File Name</th>
                                        <th>Description</th>
                                        <th>
                                            <button
                                                class="btn btn-default"
                                                style="padding: 2px 8px; margin-top: -2px"
                                                (click)="ShowCreateWindow(createAttachment)">
                                                <span class="fa-solid fa-plus"></span>
                                            </button>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    @for (attach of PORequest.Attachments; track attach) {
                                        <tr>
                                            <td>
                                                <a
                                                    style="cursor: pointer"
                                                    (click)="OpenAttachment(attach.PurchaseRequestAttachmentID)"
                                                    >{{ attach.FileName }}</a
                                                >
                                            </td>
                                            <td>{{ attach.Description }}</td>
                                            <td>
                                                <button
                                                    class="btn btn-danger"
                                                    style="padding: 2px 8px"
                                                    (click)="RemoveAttachment(attach)">
                                                    <span class="fa-solid fa-trash"></span>
                                                </button>
                                            </td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="panel panel-default">
            <div id="lineitems" class="panel-heading">
                Line Items
                <div class="pull-right">
                    <button
                        class="btn btn-default"
                        style="padding: 2px 8px; margin-top: -2px"
                        (click)="ShowCreateWindow(createLineItem)">
                        <span class="fa-solid fa-plus"></span>
                    </button>
                </div>
            </div>
            <div class="panel-body">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>Description</th>
                            <th>Quantity</th>
                            <th>Price</th>
                            <th>Total</th>
                            <th>Edit</th>
                            <th>Delete</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (item of PORequest.LineItems; track item) {
                            <tr>
                                <td>
                                    <!-- Display mode -->
                                    @if (!item.edit) {
                                        <span>{{ item.Description }}</span>
                                    }
                                    <!-- Edit mode -->
                                    @if (item.edit) {
                                        <input nz-input [(ngModel)]="item.Description" type="text" />
                                    }
                                </td>
                                <td>
                                    <!-- display mode -->
                                    @if (!item.edit) {
                                        <span>{{ item.Quantity }}</span>
                                    }
                                    <!-- edit mode -->
                                    @if (item.edit) {
                                        <input nz-input [(ngModel)]="item.Quantity" type="number" />
                                    }
                                </td>
                                <td>
                                    <!-- display mode -->
                                    @if (!item.edit) {
                                        <span>{{ item.Price | currency }}</span>
                                    }
                                    <!-- edit mode -->
                                    @if (item.edit) {
                                        <input nz-input [(ngModel)]="item.Price" type="number" />
                                    }
                                </td>
                                <td>{{ item.Price * item.Quantity | currency }}</td>
                                <td>
                                    <!-- display mode (edit icon) -->
                                    @if (!item.edit) {
                                        <button
                                            class="btn btn-default"
                                            style="padding: 2px 8px"
                                            (click)="item.edit = !item.edit">
                                            <span class="fa-solid fa-pen-to-square"></span>
                                        </button>
                                    }
                                    <!-- edit mode (save icon) -->
                                    @if (item.edit) {
                                        <button class="btn btn-default" style="padding: 2px 8px" (click)="Update()">
                                            <span class="fa-solid fa-floppy-disk"></span>
                                        </button>
                                    }
                                </td>
                                <td>
                                    <button class="btn btn-danger" style="padding: 2px 8px" (click)="RemoveItem(item)">
                                        <span class="fa-solid fa-trash"></span>
                                    </button>
                                </td>
                            </tr>
                        }
                        <tr style="border-top: 2px double black">
                            <td><b>TOTAL</b></td>
                            <td></td>
                            <td></td>
                            <td>
                                <b>{{ GetLinesItemTotal() | currency }}</b>
                            </td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="panel panel-default">
            <div id="notes" class="panel-heading">
                Notes
                <div class="pull-right">
                    <button
                        class="btn btn-default"
                        style="padding: 2px 8px; margin-top: -2px"
                        (click)="ShowCreateWindow(createNote)">
                        <span class="fa-solid fa-plus"></span>
                    </button>
                </div>
            </div>
            <div class="panel-body">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>Time</th>
                            <th>Author</th>
                            <th>Note</th>
                            <th>Edit</th>
                            <th>Delete</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (note of PORequest.Notes; track note) {
                            <tr>
                                <td>
                                    {{
                                        (note.ID === 0 ? note.NoteTime : note.NoteTime + "Z")
                                            | date: "MM/dd/yyyy h:mm a"
                                    }}
                                </td>
                                <td>
                                    {{ note.UserName }}
                                </td>
                                <td>
                                    <!-- display mode -->
                                    @if (!note.edit) {
                                        <span>{{ note.Note }}</span>
                                    }
                                    <!-- edit mode -->
                                    @if (note.edit) {
                                        <textarea [(ngModel)]="note.Note" class="form-control" style="height: auto">{{
                                            note.Note
                                        }}</textarea>
                                    }
                                </td>
                                <td>
                                    <!-- display mode (edit icon) -->
                                    @if (note.ID === 0 && !note.edit) {
                                        <button
                                            class="btn btn-default"
                                            style="padding: 2px 8px"
                                            (click)="note.edit = !note.edit">
                                            <span class="fa-solid fa-pen-to-square"></span>
                                        </button>
                                    }
                                    <!-- edit mode (save icon) -->
                                    @if (note.ID === 0 && note.edit) {
                                        <button
                                            class="btn btn-default"
                                            style="padding: 2px 8px"
                                            (click)="note.edit = !note.edit">
                                            <span class="fa-solid fa-floppy-disk"></span>
                                        </button>
                                    }
                                </td>
                                <td>
                                    @if (note.ID === 0) {
                                        <button
                                            class="btn btn-danger"
                                            style="padding: 2px 8px"
                                            (click)="RemoveNote(note)">
                                            <span class="fa-solid fa-trash"></span>
                                        </button>
                                    }
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <ng-template #createLineItem>
        <div class="modal-header">Create Line Item</div>
        <form #createLineForm="ngForm" (ngSubmit)="AddItem(createLineForm, NewRequest)" role="form">
            <div class="modal-body">
                <div class="form-group">
                    <label for="desc">Description</label>
                    <input
                        type="text"
                        name="desc"
                        [(ngModel)]="NewRequest.Description"
                        class="form-control"
                        placeholder="Enter description"
                        required />
                </div>
                <div class="form-group">
                    <label for="description">Quantity</label>
                    <input
                        type="number"
                        name="qty"
                        [(ngModel)]="NewRequest.Quantity"
                        class="form-control"
                        placeholder="Enter quantity"
                        required />
                </div>
                <div class="form-group">
                    <label for="description">Price</label>
                    <input
                        type="number"
                        step="0.01"
                        name="price"
                        [(ngModel)]="NewRequest.Price"
                        class="form-control"
                        placeholder="Enter price"
                        required />
                </div>
            </div>
            <div class="modal-footer">
                <button type="submit" class="btn btn-default">Create</button>
            </div>
        </form>
    </ng-template>

    <ng-template #createAttachment>
        <div class="modal-header">Create Attachment</div>
        <form
            enctype="multipart/form-data"
            id="addAttachmentForm"
            [noValidate]="false"
            (submit)="addAttachment($event)"
            role="form">
            <div class="modal-body">
                <input type="hidden" name="poRequestId" [value]="POID" />
                <div class="form-group">
                    <label for="fileInput">Attachment</label>
                    <input id="createAttachmentFile" name="fileInput" type="file" required />
                </div>
                <div class="form-group">
                    <label for="fileName">File Name</label>
                    <input class="form-control" name="fileName" type="text" placeholder="Enter File Name" required />
                </div>
                <div class="form-group">
                    <label for="fileDescription">Description</label>
                    <input
                        id="createAttachmentDesc"
                        name="fileDescription"
                        type="text"
                        class="form-control"
                        placeholder="Enter description" />
                </div>
            </div>
            <div class="modal-footer">
                <button type="submit" class="btn btn-default">Upload</button>
            </div>
        </form>
    </ng-template>

    <ng-template #createNote>
        <div class="modal-header">Add Note</div>
        <form id="addNoteForm" [noValidate]="false" (submit)="addNote()" action="#" role="form">
            <div class="modal-body">
                <div class="form-group">
                    <label for="note">Note</label>
                    <textarea
                        [formControl]="NoteField"
                        class="form-control"
                        style="height: 100px; margin-bottom: 15px"
                        required></textarea>
                </div>
            </div>
            <div class="modal-footer">
                <button type="submit" class="btn btn-default">Submit</button>
            </div>
        </form>
    </ng-template>

    <ng-template #cancelModal>
        <div class="modal-header">Cancel Request</div>
        <form (ngSubmit)="DoCancelItem()" role="form">
            <div class="modal-body">
                <div class="form-group">
                    <div class="control-label">Reason (optional)</div>
                    <textarea
                        [(ngModel)]="CancelRequest.CancelNotes"
                        [ngModelOptions]="{standalone: true}"
                        class="form-control"
                        style="height: 100px; margin-bottom: 15px"></textarea>
                </div>
            </div>
            <div class="modal-footer">
                <button type="submit" class="btn btn-danger">Cancel Request</button>
            </div>
        </form>
    </ng-template>

    <ng-template #denyModal>
        <div class="modal-header">Deny {{ this.DenyRequest.DenyType === 0 ? "Request" : "Order" }}</div>
        <form (ngSubmit)="DoDenyItem()" role="form">
            <div class="modal-body">
                <div class="form-group">
                    <div class="control-label">Reason (optional)</div>
                    <textarea
                        name="denyNotes"
                        [(ngModel)]="DenyRequest.DenyNotes"
                        [ngModelOptions]="{standalone: true}"
                        class="form-control"
                        style="height: 100px; margin-bottom: 15px"></textarea>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default" (click)="CloseModal()">Cancel</button>
                <button type="submit" class="btn btn-danger">
                    Deny {{ this.DenyRequest.DenyType === 0 ? "Request" : "Order" }}
                </button>
            </div>
        </form>
    </ng-template>
</div>
